// Main App Component with Routing
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Lobby from "./Lobby";
import Game from "./Game";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faTwitter, faFontAwesome } from "@fortawesome/free-brands-svg-icons";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'; // Server url

library.add(
  fas,
  faTwitter,
  faFontAwesome
);

//export const API_URL = "http://127.0.0.1:8000"; // local dev
export const API_URL = "https://www.quantenschafkopf.welmit.de";



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Lobby />} />
        <Route path="/game/:gameId/:playerId" element={<Game />} />
      </Routes>
    </Router>
  );
}

export default App;
